<template>
  <section class="subscription" id="pricing">
    <div class="my-3 px-3">
      <router-link to="/" class="ef-logo-text text-dark">
        <img src="../../assets/EliteFitAI-Logo.svg" alt="EliteFit Logo" class="ef-logo"> ELITEFIT.AI
      </router-link>
    </div>
    <div class="row mb-4">
      <div class="col-lg-12">
        <div class="title-box text-center">
          <h1 class="title-heading font-weight-bold mt-4">Choose Your EliteFit.AI Plan.</h1>
          <p class="text-muted f-17 mt-3">What Does Your Team Need?</p>
        </div>
      </div>
    </div>
    <div ref="pricingTable"></div>
  </section>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "StripeSubscriptionPlans",
  data() {
    return {
      pricingTable: process.env.VUE_APP_STRIPE_PRICING_TABLE,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
    if (this.userInfo?.isAnonymousUser) {
      this.$router.push("/smb/sign-up");
    }
    const stripePricingTable = document.createElement('stripe-pricing-table');
    stripePricingTable.setAttribute('pricing-table-id', this.pricingTable);
    stripePricingTable.setAttribute('publishable-key', this.publishableKey);
    // console.log("this.userInfo", this.userInfo);
    stripePricingTable.setAttribute('client-reference-id', this.userInfo.userId);
    stripePricingTable.setAttribute('client-reference-email', this.userInfo.email);
    this.$refs.pricingTable.appendChild(stripePricingTable);

    const script = document.createElement('script');
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.onload = () => {
      // console.log("stripe script loaded");
    };
    document.head.appendChild(script);
  }
}
</script>

<style scoped>

</style>
